/* unplugin-vue-components disabled */import { render } from "./ConfirmDialog.vue?vue&type=template&id=7072b0b8&scoped=true&ts=true"
import script from "./ConfirmDialog.vue?vue&type=script&lang=ts"
export * from "./ConfirmDialog.vue?vue&type=script&lang=ts"

import "./ConfirmDialog.vue?vue&type=style&index=0&id=7072b0b8&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7072b0b8"]])

export default __exports__